import { globalFilterActions } from '../constants/filter';

export const changeGlobalFilterEvent = (event) => ({
  type: globalFilterActions.CHANGE_EVENT,
  event,
});

export const addFilterClause = () => ({
  type: globalFilterActions.ADD_FILTER_CLAUSE,
});

export const removeFilter = (eventId) => ({
  type: globalFilterActions.REMOVE_FILTER,
  eventId,
});

export const removeFilterClause = (id) => ({
  type: globalFilterActions.REMOVE_FILTER_CLAUSE,
  id,
});

export const setFilterClauseField = (id, field, type) => ({
  type: globalFilterActions.SET_FILTER_CLAUSE_FIELD,
  id,
  field,
  fieldType: type,
});

export const setFilterClauseValue = (id, value) => ({
  type: globalFilterActions.SET_FILTER_CLAUSE_VALUE,
  id,
  value,
});

export const setClausesConcatOperator = (value) => ({
  type: globalFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  value,
});

export const setFilterClauseOperator = (id, value, resetClauseValue) => ({
  type: globalFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  id,
  value,
  resetClauseValue,
});
